import { useRootStore } from "store";
import { Icon } from "components/icon/Icon";
import Link from "components/link/Link";
import { useGlobalContext } from "app/store/GlobalContext";
import MenuDropdown from "components/menu/MenuDropdown/MenuDropdown";

import "./MenuDropdown.scss";

export default function UserHeaderMenu() {
  const { handleNavigation } = useGlobalContext();
  const { user } = useRootStore((state) => state);
  const headerMenuItems = [
    {
      to: "/settings",
      title:
        "När du klickar på Mina inställningar kan du göra inställningar för Notifieringar till din e-post när du har fått ett nytt meddelande.",
      text: "Mina inställningar",
    },
  ];

  const menuItems = [
    {
      content: (
        <h1>
          <div>
            {user.userInfo && user.userInfo.givenName}{" "}
            {user.userInfo && user.userInfo.surName}
          </div>
        </h1>
      ),
      notClickable: true,
    },
    {
      content: <div>{user.userInfo && user.userInfo.email}</div>,
      hasDivider: true,
      notClickable: true,
    },
  ];

  const additionalMenuItems = headerMenuItems.map((item) => ({
    content: (
      <h3 title={item.title}>
        <Icon className="dropdownMenuItemDot" name="far fa-circle-o" />
        {item.text}
      </h3>
    ),
    onClick: (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
      handleNavigation({ url: item.to, eventTitle: item.title, e: e });
    },
  }));

  const allMenuItems = [...menuItems, ...additionalMenuItems];

  return (
    <>
      <div className="userDropdown">
        <MenuDropdown
          toggleText={`${user.userInfo && user.userInfo.givenName} ${
            user.userInfo && user.userInfo.surName
          }`}
          menuItems={allMenuItems}
        />
      </div>
      <div className="userMenuFullscreen">
        <h2>
          {user.userInfo && user.userInfo.givenName}{" "}
          {user.userInfo && user.userInfo.surName}
        </h2>
        <ul>
          {headerMenuItems.map((menuItem) => (
            <li key={menuItem.title}>
              <Link
                to={menuItem.to}
                title={menuItem.title}
                onClick={(e) =>
                  handleNavigation({
                    url: menuItem.to,
                    eventTitle: menuItem.title,
                    e: e,
                  })
                }
              >
                <Icon className="dropdownMenuItemDot" name="far fa-circle-o" />
                {menuItem.text}
              </Link>
            </li>
          ))}
        </ul>
      </div>
    </>
  );
}
